var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPizza(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pizza"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.82813 6.01305C1.7412 5.87774 1.71051 5.71385 1.74262 5.55625C1.77472 5.39866 1.86707 5.25983 2 5.1693C4.33264 3.49775 7.13028 2.59885 10 2.59885C12.8697 2.59885 15.6674 3.49775 18 5.1693C18.1329 5.25983 18.2253 5.39866 18.2574 5.55625C18.2895 5.71385 18.2588 5.87774 18.1719 6.01305L10.5234 18.0209C10.468 18.1097 10.3908 18.1829 10.2992 18.2336C10.2077 18.2844 10.1047 18.311 10 18.311C9.8953 18.311 9.79232 18.2844 9.70076 18.2336C9.60919 18.1829 9.53204 18.1097 9.47656 18.0209L1.82813 6.01305Z",
    stroke: "url(#paint0_linear_7937_33996)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.86719 7.64587C4.87914 5.99821 7.39947 5.0979 10 5.0979C12.6005 5.0979 15.1209 5.99821 17.1328 7.64587",
    stroke: "url(#paint1_linear_7937_33996)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.8359 14.3881C12.5084 14.2948 12.2072 14.1263 11.9563 13.8961C11.7054 13.6659 11.5116 13.3803 11.3905 13.062C11.2695 12.7437 11.2244 12.4016 11.2588 12.0628C11.2933 11.724 11.4064 11.398 11.5891 11.1106C11.7718 10.8232 12.019 10.5825 12.3112 10.4075C12.6034 10.2325 12.9323 10.1282 13.2719 10.1028C13.6115 10.0774 13.9523 10.1316 14.2673 10.2612C14.5822 10.3907 14.8625 10.592 15.0859 10.849",
    stroke: "url(#paint2_linear_7937_33996)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.52344 10.2396C4.66838 9.86907 4.91165 9.54507 5.22706 9.3025C5.54246 9.05994 5.91805 8.90799 6.31339 8.86302C6.70874 8.81805 7.10886 8.88176 7.47068 9.04729C7.83251 9.21282 8.14233 9.47391 8.3668 9.80244C8.59127 10.131 8.72188 10.5145 8.74457 10.9118C8.76726 11.309 8.68117 11.7049 8.49558 12.0569C8.30998 12.4088 8.0319 12.7035 7.69128 12.9091C7.35066 13.1148 6.96039 13.2237 6.5625 13.224H6.42187",
    stroke: "url(#paint3_linear_7937_33996)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7937_33996",
    x1: 14.7614,
    y1: 17.1207,
    x2: 4.83336,
    y2: 2.12067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECB917"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7937_33996",
    x1: 14.1068,
    y1: 7.45284,
    x2: 13.6781,
    y2: 4.00811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECB917"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7937_33996",
    x1: 14.2717,
    y1: 14.063,
    x2: 11.4156,
    y2: 10.3962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECB917"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7937_33996",
    x1: 7.85198,
    y1: 12.8926,
    x2: 5.00197,
    y2: 8.94249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECB917"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPizza);
export default __webpack_public_path__ + "static/media/pizza.6a74beb01974f0bc525e99a379ecc64e.svg";
export { ForwardRef as ReactComponent };